export default {
  message_not_edited_error:
    'El mensaje no se ha guardado. Int\u00e9ntalo de nuevo.',
  CANCEL: 'Cancelar',
  SAVING: 'Guardando',
  generic_save: 'Guardar',
};
